import {Component, OnInit} from '@angular/core';
import {NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {RestApiService} from './core/services/rest-api.service';
import {RuntimeCacheService} from './core/services/runtime-cache.service';
import {NotificationService} from './core/services/notification-service';
import {registerLocaleData} from '@angular/common';
import {filter} from 'rxjs';
import {GlobalRouteConfig} from './app.config';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import localeENExtra from '@angular/common/locales/extra/en';
import {YascSignalrService} from '@yasc/yasc-material-components';
import {SocketTopic} from './core/enums';
import {CpNotification} from './core/contracts/socket/notification-req';

@Component({
    selector: 'cp-root',
    templateUrl: './app.component.html',
    imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
    constructor(
        private restapi: RestApiService,
        private runtime: RuntimeCacheService,
        private router: Router
    ) {
        registerLocaleData(localeDe, 'de-DE', localeDeExtra);
        registerLocaleData(localeDe, 'en-US', localeENExtra);

        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((ev: any) => {
                if (ev instanceof NavigationEnd) {
                    GlobalRouteConfig.previousUrl = ev.url;
                }
            });
    }

    ngOnInit(): void {
        this.restapi.v0.misc.getSupportedCultures().subscribe(val => {
            this.runtime.supportedCultures = val.data;
        })
    }
}
